import { navigateToEvent } from 'components/tables/common/navigateToEvent';
import { editEvent } from '../eventsTab/editEvent';
import { isFunction } from 'functions/typeOf';

export const eventFromParticipants = (table: any, callback?: (result?: any) => void): void => {
  const selected = table.getSelectedData();
  const active = table.getData('active').map((a: any) => a.participantId);
  const participants = selected.filter((s: any) => active.includes(s.participantId));

  const postEventCreation = (result: any) => {
    table.deselectRow();
    if (result?.success) {
      const eventId = result?.results[0]?.event?.eventId;
      if (isFunction(callback) && callback) {
        callback({ eventId });
      } else if (eventId) navigateToEvent({ eventId });
    } else if (isFunction(callback) && callback) callback();
  };

  editEvent({ table, callback: postEventCreation, participants });
};
